"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertor = exports.taskFromOperationNode = void 0;
const common_1 = require("@finley-technologies/common");
const converterUtils_1 = require("../converterUtils");
const types_1 = require("./types");
const taskToOperationNode = (task) => {
    const { srcArtifactSlug: _unused2, ...nodeConfiguration } = task;
    return (0, converterUtils_1.newOperationNode)(types_1.nodeType, nodeConfiguration);
};
const taskFromOperationNode = ({ srcNodes, operationNode, }) => {
    const { configuration } = operationNode;
    (0, common_1.finleyAssert)(srcNodes.length === 1, `edit node has [${srcNodes.length}] src node`);
    return {
        srcArtifactSlug: (0, converterUtils_1.getSrcArtifactSlug)(srcNodes[0]),
        ...configuration,
    };
};
exports.taskFromOperationNode = taskFromOperationNode;
exports.convertor = {
    operation: 'filter',
    nodeType: types_1.nodeType,
    taskToOperationNode,
    taskFromOperationNode: exports.taskFromOperationNode,
    toTransformation: (task, resolveDef) => {
        const { operation, srcArtifactSlug, filterFormula } = task;
        const srcDataTape = resolveDef(srcArtifactSlug);
        if (!srcDataTape.isValid) {
            return {
                isValid: false,
                errors: srcDataTape.errors,
            };
        }
        (0, common_1.finleyAssert)(srcDataTape.data, 'TapeDefinition is null for filter operation inputs');
        return {
            isValid: true,
            data: {
                operation,
                srcDataTape: srcDataTape.data,
                filterFormula,
            },
        };
    },
};
//# sourceMappingURL=converter.js.map